import React from 'react'
import Typography from '@material-ui/core/Typography'

const PaperTitle = ({ title }) => {
    return <Typography variant="h5">{title}</Typography>
}

export default PaperTitle
